import React, { useEffect, useRef } from "react";
import { Accordion } from "react-bootstrap";
import "./Faq.scss";
import { ENV } from "utils/helper";

const polygonSwapContractCode =
  process.env.REACT_APP_ENV === ENV.STAGING
    ? ` https://mumbai.polygonscan.com/address/${process.env.REACT_APP_POLYGON_TVK_SWAP_CONTRACT}#code`
    : `https://polygonscan.com/address/${process.env.REACT_APP_POLYGON_TVK_SWAP_CONTRACT}#code`;

const ethereumSwapContractCode =
  process.env.REACT_APP_ENV === ENV.STAGING
    ? ` https://sepolia.etherscan.io/address/${process.env.REACT_APP_ETHEREUM_TVK_SWAP_CONTRACT}#code`
    : `https://etherscan.io/address/${process.env.REACT_APP_ETHEREUM_TVK_SWAP_CONTRACT}#code`;

const Faq = () => {
  const accordionRef = useRef(null);

  useEffect(() => {
    const hash = window.location.hash;

    if (hash && accordionRef.current) {
      const targetElement = accordionRef.current.querySelector(hash);
      // console.log(targetElement);

      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  });

  return (
    <section className="faq-section">
      <div className="container">
        <div className="titleMargin">
          <h2 className="section-title">FAQ</h2>
        </div>

        <Accordion defaultActiveKey="1" ref={accordionRef}>
          <h3 className="accordion-title titleMargin-20">Token Swap</h3>
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              How can I swap my $TVK tokens for $VANRY tokens?
            </Accordion.Header>
            <Accordion.Body>
              <p>The migration process is simple and straightforward.</p>
              <ul>
                <li>
                  Visit our official swap website,{" "}
                  <a href="/" className="highlight">
                    swap.vanarchain.com
                  </a>
                  , starting from December 1st, 2023.
                </li>
                <li>Connect your wallet.</li>
                <li>Enter amount to swap</li>
                <li>Press the swap button.</li>
                <li>Your $TVK tokens will be converted into $VANRY tokens.</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>What is the migration date?</Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">The swap starts on December 1st, 2023.</p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>
              How do I participate in the token swap?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                To participate, you need to connect your wallet (e.g., Metamask,
                hardware wallet) to the platform, and the swap process is as
                simple as clicking a button.
              </p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>
              Is there a fee for participating in the token swap?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                The only fees will be the network fees (gas fees) on Ethereum or
                Polygon. The exact fee will depend on the network congestion and
                other factors.
              </p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="5">
            <Accordion.Header>
              Can I use any wallet for the token swap?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                Yes, you can use traditional wallets like Metamask or hardware
                wallets to participate in the token swap. Ensure that your
                wallet supports the Ethereum or Polygon network.
              </p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="6">
            <Accordion.Header>
              What is the swap/conversion ratio for $TVK to $VANRY tokens?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                The swap ratio is 1:1, meaning for every $TVK token you swap,
                you will receive one $VANRY token in return.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          {/* 
          <Accordion.Item eventKey="7">
            <Accordion.Header>
              Is there a time limit for the token swap?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                The token swap will be open for a 12 month period from December
                1st 2023. Make sure to check the platform for the start and end
                dates of the swap.
              </p>
            </Accordion.Body>
          </Accordion.Item> */}

          <Accordion.Item eventKey="7">
            <Accordion.Header>
              What happens to any $TVK tokens after the token swap period has
              ended?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                The $TVK tokens that are not migrated will remain as $TVK
                tokens. $VANRY will be an upgrade and renaming of the $TVK token
                and will assume all utility of the current $TVK token. By not
                migrating those $TVK will effectively be considered burned from
                supply.
              </p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="8">
            <Accordion.Header>
              Why not conduct an airdrop of the $VANRY token?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                An airdrop would result in the existence of two distinct tokens,
                while the goal is for $VANRY to replace $TVK entirely.
              </p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="9">
            <Accordion.Header>
              Where can I find the smart contracts for the migration and has it
              been audited?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                The smart contract code is available for{" "}
                <a href={ethereumSwapContractCode} className="highlight">
                  Ethereum (ETH)
                </a>{" "}
                and{" "}
                <a href={polygonSwapContractCode} className="highlight">
                  Polygon
                </a>
                , and has been audited by Immunebytes, with the report available{" "}
                <a
                  href="https://drive.google.com/file/d/13ME276us3-To-orsqj_eUSiSkyODegY8/view"
                  className="highlight"
                >
                  here
                </a>
                .
              </p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="10">
            <Accordion.Header>
              Can I bridge $VANRY to the VANAR network?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                No, you cannot bridge $TVK to the Vanar Chain until the mainnet
                has been launched.
              </p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="11">
            <Accordion.Header>
              Can I migrate $TVK to the VANAR network?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                No, $TVK as it is, is intended to be getting replaced. It will
                not be supported by Vanar Chain mainnet.
              </p>
            </Accordion.Body>
          </Accordion.Item>

          {/* <Accordion.Item eventKey="12">
            <Accordion.Header>
              What will happen to my $TVK on the VANAR network?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                $TVK will cease to exist. The native token on Vanar will be
                $VANRY and will function as a native for gas and as a wrapped
                ERC-20 token required by some dApps. I.e. DEX Routing.
              </p>
            </Accordion.Body>
          </Accordion.Item> */}

          <Accordion.Item eventKey="12">
            <Accordion.Header>
              How can I stay updated on the token swap platform's announcements
              and news?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                You can follow our official X channel at{" "}
                <a
                  href={process.env.REACT_APP_TWITTER_URL}
                  className="highlight"
                >
                  x.com/vanarchain
                </a>
                , subscribe to our newsletter, or regularly visit the platform's
                website at{" "}
                <a href="https://vanarchain.com/" className="highlight">
                  www.vanarchain.com
                </a>{" "}
                for updates, announcements, and news related to the token swap.
              </p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="13">
            <Accordion.Header>
              What if I have more questions or encounter issues during the token
              swap process?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                If you have any questions or encounter issues, please contact
                our customer support team through the provided contact
                information on the platform. We're here to assist you.
              </p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="14">
            <Accordion.Header>
              Can I swap $VANRY tokens back to $TVK tokens?
            </Accordion.Header>
            <Accordion.Body>
              <p>
                This platform is designed specifically for swapping $TVK to
                $VANRY tokens. To swap $VANRY tokens back to $TVK, you may need
                to explore other platforms or exchanges that support this
                conversion.
              </p>
              <p className="mb-0">
                Please note that the information provided in this FAQ is subject
                to change, so it's essential to refer to the platform's official
                website and announcements for the most up-to-date information
                regarding the token swap.
              </p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="15">
            <Accordion.Header>
              What exchanges are supporting the swap?
            </Accordion.Header>
            <Accordion.Body>
              <p>
                We have reached out to all major exchanges and are in
                communications with them to ensure smooth transition from $TVK
                to $VANRY token on-chain and off-chain on their exchanges. As we
                confirm which exchanges are supporting our token swap we will
                list them here:
              </p>
              <ul>
                <li>Binance</li>
                <li>Kucoin</li>
                <li>Gate</li>
                <li>Paribu</li>
                <li>MEXC</li>
                <li>CoinEx</li>
                <li>Bitget</li>
              </ul>
              <p>We are currently in discussion with:-</p>
              <ul>
                <li>Coinbase</li>
                <li>Bybit</li>
                <li>Kraken</li>
                <li>Ascendex</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="16">
            <Accordion.Header>
              How can I stay connected with the latest information?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                Follow us on Twitter:{" "}
                <a
                  href={process.env.REACT_APP_TWITTER_URL}
                  className="highlight"
                >
                  https://twitter.com/vanarchain
                </a>
              </p>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="17" id="confirm-stake">
            <Accordion.Header>
              I'm getting an error when confirming swap on Metamask. Why?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                When swapping with Metamask, ensure that you approve the exact
                number of tokens you intend to swap. There is a known issue
                where Metamask might slightly reduce the approved amount. Always
                double-check that the approval matches your intended swap. For
                example, if you plan to stake 50,000 tokens, make sure you have
                approved exactly 50,000 tokens in Metamask, not 49,999.95 or any
                other reduced number. If you have already approved the wrong
                amount via Metamask by mistake, when confirming, reduce the
                amount you are looking to confirm for the swap. Usually, it will
                be based on a fraction, so reducing by 1 TVK should work.
              </p>
            </Accordion.Body>
          </Accordion.Item>

          {/* <h3 className="accordion-title titleMargin-20 mid">Pre-stake $TVK</h3>
          <Accordion.Item eventKey="18">
            <Accordion.Header>
              What is pre-staking for $TVK tokens?
            </Accordion.Header>
            <Accordion.Body>
              <p>
                Pre-staking allows you to stake your $TVK now and receive $VANRY
                on VANAR Mainnet which will be launched in Q1 2024
              </p>
              <p>Benefits of Pre-staking include:</p>
              <ul>
                <li>
                  No need to worry about bridging or converting your ERC20
                  tokens to the VANAR Mainnet
                </li>
                <li>Bonus Tokens</li>
                <li>Mainnet staking rewards</li>
              </ul>
              <p>You can stake using Ethereum or Polygon networks.</p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="19">
            <Accordion.Header>
              How much rewards (APR) do I get for pre-staking my $TVK tokens?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                You can see how much rewards are up for grabs at{" "}
                <a href="https://staking.vanarchain.com/">
                  staking.vanarchain.com
                </a>
                . You can earn up to 800% APR. You can collect this reward along
                with your 1:1 token swap on the new Vanar chain after it goes
                live in Q1 2024.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="20">
            <Accordion.Header>
              How do I get in on the pre-staking action?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                Visit{" "}
                <a href="https://staking.vanarchain.com/">
                  staking.vanarchain.com
                </a>{" "}
                or click the "Stake & Earn" button above. Connect your wallet,
                choose how many $TVK tokens to stake, and you're all set!
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="21">
            <Accordion.Header>
              When is the deadline to pre-stake?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                Pre-staking your $TVK will only be open for a limited time
                period. You can join pre-staking right up until the token swap
                starts. You'll still earn rewards until the Vanar Mainnet goes
                live. We'll keep you posted on the exact timeline.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="22">
            <Accordion.Header>
              When can I claim my tokens back after pre-staking?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                Once your $TVK tokens are pre-staked, they stay locked until the
                Vanar mainnet launches in Q1 2024. Then, you can get your new
                $VANRY tokens and any rewards you've earned.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="23">
            <Accordion.Header>
              What should I look out for during the pre-staking period?
            </Accordion.Header>
            <Accordion.Body>
              <p>Keep these milestones in mind:</p>
              <ul>
                <li>Pre-staking begins.</li>
                <li>Token swap happens.</li>
                <li>Pre-staking ends when the token swap starts.</li>
                <li>
                  You keep racking up rewards until the new Vanar chain is
                  ready, and then you'll get your tokens there.
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="24">
            <Accordion.Header>
              How will I get my tokens and rewards on the Vanar chain?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                After the Vanar chain goes live, you can collect your tokens and
                rewards on the $VANRY staking platform. We'll give you the
                step-by-step when the time comes.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="25">
            <Accordion.Header>
              What about transaction fees on the new chain?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                We've got you covered with $VANRY gasless transactions so you
                can claim your rewards and 1:1 token swap hassle-free.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="26">
            <Accordion.Header>
              What's going to happen to my pre-staked $TVK?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                Think of your pre-staked $TVK as going into hibernation. Once
                everyone has their new $VANRY tokens post-launch, we'll say a
                warm goodbye to the old $TVK by burning them. It's a one-way
                swap for your tokens to their new form on the Vanar chain.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="27">
            <Accordion.Header>
              Is there a max amount I can stake?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                Stake as much $TVK as you want. There's no cap.
              </p>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="28" id="confirm-stake">
            <Accordion.Header>
              I'm getting an error when confirming staking on Metamask. Why?
            </Accordion.Header>
            <Accordion.Body>
              <p className="mb-0">
                When staking with Metamask, ensure you approve the exact number
                of tokens you want to stake. There's a known issue where
                Metamask might slightly reduce the approved amount. Always
                double-check the approval matches your intended stake. Example:
                If you plan to stake 50,000 tokens, make sure you've approved
                50,000 tokens in Metamask, not 49,999.95 or any other reduced
                number. If you already approved the wrong amount via Metamask by
                mistake, when confirming lessen the amount you are looking to
                confirm to stake. Usually it’ll be based on a fraction so
                reducing by 1 TVK should work.
              </p>
            </Accordion.Body>
          </Accordion.Item> */}
        </Accordion>
      </div>
    </section>
  );
};

export default Faq;
